import { PureComponent } from 'react';

import {
  Field,
  Formik,
  type FormikConfig,
  type FormikProps,
  type FormikState,
} from 'formik'

import { FormAsyncSelect } from './AsyncSelect'
import { FormCheckbox } from './Checkbox'
import { FormSection } from './components/FormSection'
import { FormDateOfBirthField } from './DateOfBirthField'
import { FormDateRangePicker } from './DateRangePicker'
import { FormContent } from './FormContent'
import { FormControl } from './FormControl'
import { FormMaskedTextField } from './MaskedTextField'
import { FormNumberField } from './NumberField'
import { FormPhoneNumberField } from './PhoneNumberField'
import { FormSelect } from './Select'
import { FormSingleDatePicker } from './SingleDatePicker'
import { TextField } from './TextField'
import { FormToggle } from './Toggle'

export interface FormProps<T> extends FormikProps<T> {}

export interface IFormProps<T = object> extends FormikConfig<T> {}

export class Form<Values = object, ExtraProps = {}> extends PureComponent<
  IFormProps<Values> & ExtraProps,
  FormikState<Values>
> {
  static readonly Content = FormContent
  static readonly Section = FormSection
  static readonly TextField = TextField
  static readonly Field = Field // Default Formik <Field> component
  static readonly FormControl = FormControl
  static readonly Select = FormSelect
  static readonly SingleDatePicker = FormSingleDatePicker
  static readonly DateRangePicker = FormDateRangePicker
  static readonly AsyncSelect = FormAsyncSelect
  static readonly Toggle = FormToggle
  static readonly Checkbox = FormCheckbox
  static readonly NumberField = FormNumberField
  static readonly MaskedTextField = FormMaskedTextField
  static readonly DateOfBirthField = FormDateOfBirthField
  static readonly PhoneNumberField = FormPhoneNumberField
  render() {
    return <Formik {...this.props} />
  }
}
